import React from "react";
import OutlinedButton from "../Components/OutlinedButton";
const NavBar: React.FC<Props> = ({background, logo, switchLabel, onSwitch}) => {

  // Switches between the Lui and Lei pages
  const switchButton = (
    <button
      className="min-h-[44px] inline-flex items-center gap-2 text-white text-2xs font-medium tracking-[.14em] uppercase whitespace-nowrap hover:opacity-70 active:opacity-60"
      onClick={onSwitch}
    >
      Passa a {switchLabel}
      <svg width="16" height="10" viewBox="0 0 16 10" fill="none" stroke="currentColor" strokeWidth="1.2" aria-hidden="true">
        <path d="M0 5h14M10 1l4 4-4 4"/>
      </svg>
    </button>
  );

  return (
    <nav
      className={`${background}  2xl:h-[100px] h-[60px] fixed w-full top-0 left-0`}
    >
      <div className="2xl:visible invisible 2xl:h-full h-0 px-48">
        <div className="flex items-center justify-between mx-auto p-6 gap-6">
          <div>
            <a href="./"><div className={`h-[50px] w-[100px] ${logo} bg-image`}/></a>
          </div>
          <div className="flex items-center gap-10">
            {switchButton}
            <OutlinedButton href={"https://tribeauty.it/MR.TREWAN"} download={false} color="white">Clicca e Prenota Ora</OutlinedButton>
          </div>
        </div>
      </div>
      <div className="2xl:invisible visible 2xl:h-0 h-full relative">
        <div className="flex flex-wrap items-center 2xl:justify-start justify-center mx-auto p-3 gap-6">
          <div>
            <a href="./"><div className={`h-[37.5px] w-[75px] ${logo} bg-image`}/></a>
          </div>
        </div>
        {/* Right edge, so the logo stays centred */}
        <div className="absolute right-4 inset-y-0 flex items-center">
          {switchButton}
        </div>
      </div>
    </nav>
  )
};

export default NavBar;

interface Props {
  background: string,
  logo:string,
  switchLabel: 'Lui' | 'Lei',
  onSwitch: () => void
}
